import type { ReactNode } from 'react';
import { Container } from '@/components/Container';
import { AppLink } from '@/components/AppLink';
import { DraftMarker } from '@/components/DraftMarker';
import { FILES } from '@/data/files';

function Fact({ value, children }: { value: string; children: ReactNode }) {
  return (
    <div className="border-t-2 border-navy-800 pt-4">
      <p className="m-0 font-serif text-[2.75rem] leading-none font-semibold text-navy-900">{value}</p>
      <div className="mt-2.5 mb-0 text-[1rem] leading-[1.45] text-ink-2">{children}</div>
    </div>
  );
}

// A light band (not navy): the footer is navy, and two dark blocks near each
// other read as one heavy slab.
export function FactsBand() {
  return (
    <section aria-label="ITES at a glance" className="border-y border-rule-tint bg-sky-50">
      <Container className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,220px),1fr))] gap-x-10 gap-y-7 py-[clamp(36px,5vw,56px)]">
        <Fact value="1941">Founded in Mumbai by nine founder members</Fact>
        <Fact value="1,575+">
          Affiliated institutions
          <DraftMarker className="mt-2.5 block">VERIFY · the board database (July 2026) shows 288 active of 1,820 registered institutes</DraftMarker>
        </Fact>
        <Fact value="30,000+">
          Students examined every year
          <DraftMarker className="mt-2.5 block">VERIFY · the board database shows about 5,000 student records a year since 2017</DraftMarker>
        </Fact>
        <Fact value="ISO">
          Certificate issued by UQSR
          <span aria-hidden="true" className="hidden sm:inline"> · </span>
          {/* Stacked (and tap-sized) on a phone; inline after the sentence from tablet up. */}
          <span className="block sm:inline">
            <AppLink href={FILES.isoCertificate ?? "/notices"} className="tap underline">View PDF</AppLink>
          </span>
          <DraftMarker className="mt-2.5 block">VERIFY · the certificate supplied expired 22 Aug 2026; get the current one</DraftMarker>
        </Fact>
      </Container>
    </section>
  );
}
